import { render, staticRenderFns } from "./field-text.vue?vue&type=template&id=212e7bde"
import script from "./field-text.vue?vue&type=script&lang=js"
export * from "./field-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports